import { useMutation } from '@gogame/query';

import { updateConversionPage } from 'scenes/Gallery/ConversionPages/ConversionPages/sources/conversion-pages';

import { conversionPagesUpdate } from '../queryKeyFactory';

export const useUpdateConversionPage = () => {
  const updateMutation = useMutation(
    conversionPagesUpdate(),
    updateConversionPage,
    {
      successMessage: () => 'Tags updated',
    }
  );

  return [updateMutation.mutateAsync, updateMutation];
};
